export default "__VITE_ASSET__DDaeja1u__"